var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.55 1.1a7.45 7.45 0 1 0 0 14.9 7.45 7.45 0 0 0 0-14.9ZM0 8.55a8.55 8.55 0 1 1 17.1 0 8.55 8.55 0 0 1-17.1 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.54 1.266c-.525.696-.998 1.88-1.3 3.397l-.001.002A19.53 19.53 0 0 0 4.87 8.55c0 1.41.137 2.734.37 3.886v.002c.301 1.52.774 2.695 1.3 3.397l-.88.66c-.664-.888-1.181-2.242-1.5-3.842a20.968 20.968 0 0 1-.39-4.103c0-1.478.138-2.87.39-4.104.319-1.593.835-2.959 1.5-3.842l.88.662ZM11.86 4.658c-.301-1.516-.774-2.695-1.304-3.397L11.434.6c.67.888 1.188 2.249 1.505 3.843a21.04 21.04 0 0 1 .391 4.103c0 1.474-.143 2.88-.39 4.103-.319 1.599-.835 2.96-1.507 3.845l-.876-.666c.528-.695 1.001-1.873 1.304-3.394v-.002c.232-1.147.369-2.48.369-3.886 0-1.405-.137-2.729-.37-3.887Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.55 9.1h-16V8h16v1.1Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 16.55v-16h1.1v16H8Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.153 4.173c-1.75.907-4.07 1.452-6.603 1.452-2.533 0-4.852-.54-6.609-1.452l.508-.976c1.573.818 3.713 1.328 6.101 1.328 2.387 0 4.527-.515 6.097-1.328l.506.976ZM8.55 12.415c-2.387 0-4.527.515-6.101 1.333l-.508-.976c1.756-.912 4.076-1.457 6.609-1.457 2.533 0 4.853.545 6.603 1.452l-.506.976c-1.57-.813-3.71-1.328-6.097-1.328Z"
})));
export default SvgGlobeIcon;